import { getHandler } from 'src/utils/fetchHandler';

export const GET_ACTIVITY_STATUSES = 'GET_ACTIVITY_STATUSES/ACTIVITY_STATUSES/@WISELY/WEB';
export const FETCH_ACTIVITY_STATUSES_SUCCEEDED =
	'FETCH_ACTIVITY_STATUSES_SUCCEEDED/ACTIVITY_STATUSES/@WISELY/WEB';
export const FETCH_ACTIVITY_STATUSES_FAILED =
	'FETCH_ACTIVITY_STATUSES_FAILED/ACTIVITY_STATUSES/@WISELY/WEB';

export const getActivityStatuses = () => ({
	type: GET_ACTIVITY_STATUSES,
});

export const fetchActivityStatusesSucceeded = payload => ({
	type: FETCH_ACTIVITY_STATUSES_SUCCEEDED,
	payload,
});

export const fetchActivityStatusesFailed = payload => ({
	type: FETCH_ACTIVITY_STATUSES_FAILED,
	payload,
});

export const fetchActivityStatuses = () => {
	return dispatch => {
		dispatch(getActivityStatuses());
		const path = `v2/activity_statuses`;

		return getHandler(path)
			.then(json => dispatch(fetchActivityStatusesSucceeded(json)))
			.catch(error => {
				console.error('fetchActivityStatuses error', error);
				dispatch(fetchActivityStatusesFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/activityStatuses/activityStatus.action.js